import type { AxiosInstance } from 'axios';
import type { AgendyAisAgendaAisSeznamDto } from '../generated';

export const agendasAisQuery = async (
	axiosInstance: AxiosInstance
): Promise<AgendyAisAgendaAisSeznamDto> => {
	const { data } = await axiosInstance.get('/api/v1/agendyais');
	return data;
};
